<h2>Bundle Contents</h2>
<div *ngFor="let bundleItem of bundleItems" class="productList">
    <div class="row">
        <div class="form-group mb-3 col-md-4">
            <label for="PackageType">Entry Type</label>
            <select class="form-control" id="PackageType" [(ngModel)]="bundleItem.EntryType" (change)="dataChanged()">
                <option value="0">Undefined</option>
                <option value="LOCAL">Local</option>
                <option value="PREMIER">Premier</option>
                <option value="PREMIERPLUS">PremierPlus</option>
            </select>
        </div>

        <div class="form-group mb-3 col-md-4">
            <label for="PackageType">Package Type</label>
            <select class="form-control" id="PackageType" [(ngModel)]="bundleItem.PackageType" (change)="dataChanged()">
                <option value="0">Undefined</option>
                <option value="LOCAL">Local</option>
                <option value="HALFSTEP">Half Step</option>
                <option value="SILVER">Silver</option>
                <option value="GOLD">Gold</option>
                <option value="PLATINUM">Platinum</option>
                <option value="PREMIER">Premier</option>
                <option value="ELITE">Elite</option>
                <option value="GLOBAL">Global</option>
            </select>
        </div>

        <div class="col-md-4 d-flex align-items-center">
            <button type="button" class="btn btn-primary productPrices__saveButton mr-2" (click)="saveItem(bundleItem)">
                <span>Save</span>
            </button>
            <button type="button" class="btn btn-danger productPrices__saveButton" (click)="deleteItem(bundleItem)">
                <span>Delete</span>
            </button>
        </div>
    </div>
    <hr />
</div>